import React, { PureComponent } from 'react';
import cn from 'classnames'
import injectSheet from 'react-jss'
import GalleryItem from './GalleryItem'
import CentredContentContainer from "../Widgets/CentredContentContainer"

class LookbookGallery extends PureComponent {

    componentWillUnmount = () => {
        if (this.packery) {
            this.packery.destroy()
            delete this.packery
        }
    }

    _initPackery = (el) => {
        if (this.packery && this.packery.element !== el) {
            this.packery.destroy()
            delete this.packery
        }
        if (el) {
            import(/* webpackChunkName: 'flickity' */ 'packery').then(module => {
                this.packery = new module( el, {
                    percentPosition: true,
                });
            });
        }
    }

    render() {
        const {key, containerSize, galleryImages, classes} = this.props;

        let smallItemRequired = galleryImages.filter( item => item.images.type === "portrait" ).length % 2 === 1;
        let spaceUsed = 0
        let items = galleryImages.map( (item, i) => {
            let className;
            let image;
            let aspect;
            if(item.images.type === "portrait") {
                spaceUsed += 2;
                className = classes.gridItem;
                image = {desktop: item.images.hero, blur: [item.images.heroBlur]};
                aspect = 1.5;
            } else {
                image = {desktop: item.images.main, blur: [item.images.blur]};
                aspect = 0.729;
                if (spaceUsed%4 !== 0 || smallItemRequired) {
                    className = cn(classes.gridItem, classes.gridItemFullWidthHalfHeight);
                    spaceUsed += 1;
                    smallItemRequired = false;
                } else {
                    spaceUsed += 4;
                    className = cn(classes.gridItem, classes.gridItemFullWidth);
                }
            }
            return <GalleryItem key={i} className={className} item={item} image={image} aspect={aspect} video={item.video} />
        });

        return (
            <section>
                <CentredContentContainer size={containerSize}>
                    <div key={key} className={classes.gridWrapper} ref={this._initPackery}>
                        {items}
                    </div>
                </CentredContentContainer>
            </section>
        );
    }
}

export default injectSheet(theme => ({
    gridWrapper: {
        margin: 0,
        [theme.breakpoint('tablet')]: {
            margin: '-1%'
        }
    },
    gridItem: {
        width: '100%',
        [theme.breakpoint('mobile')]: {
            width: '50%',
        },
        padding: '1%',
        '& > div': {
            position: 'relative'
        }
    },
    gridItemFullWidthHalfHeight: {
        width: '100%',
        [theme.breakpoint('mobile')]: {
            width: '50%',
        }
    },
    gridItemFullWidth: {
        width: '100%',
    },
    imageContainer: {},
    footerLogo: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: theme.colors.assent,
        fontSize: theme.font.info.fontSize,
        fontWeight: theme.font.info.fontWeight,
        lineHeight: theme.font.info.lineHeight,
    },
}))(LookbookGallery);



// WEBPACK FOOTER //
// ./src/components/Lookbook/LookbookGallery.js